export default "__VITE_ASSET__6dc8e6db__"